import React, {useContext, useState} from 'react';
import {updatePaymentPlansAndBuy} from '../../api/buyAPI';
import {ModelContext} from "../metadata/ModelSource";

export function BuyStep() {

  const [status, setStatus] = useState(null);
  const appModel = useContext(ModelContext);

  const buyPolicy = async () => {
    await updatePaymentPlansAndBuy(
      appModel.data,

      {
        // downPaymentAmount: '500', //???

        paymentTypeCd: "None",
        payPlanCd: "Direct Pay In Full-NB",
        paymentDay: "1",
        electronicPaymentSource: {
          methodCd: "ACH",
          // paymentMethod: "string",
          achName: "Smith, Joe",
          achBankName: "BOFA",
          achBankAccountTypeCd: "Checking",
          achBankAccountNumber: "123456789",
          achRoutingNumber: "011001959",
          achStandardEntryClassCd: "PPD",
          // customerProfileId: "string",
          // customerPaymentProfileId: "string"
        }
      },
      () => setStatus('SUCCESS'),
      errorMsg => setStatus(errorMsg));
  };

  return <div>
    {status && <div>{status}</div>}
    <button onClick={buyPolicy}>Buy!</button>
  </div>

}